import { RadioGroup, RadioOnChangeData } from "@fluentui/react-components";
import { FormEvent, useCallback, useMemo } from "react";
import { SuggestionSearchMode } from "../../types/enums";
import { SearchModeRadio } from "./components/SearchModeRadio";
import { useSuggestionTypeSwitchStyles } from "./styles";

export type SuggestionTypeSwitchProps = {
  type: SuggestionSearchMode;
  enableTooltip?: boolean;
  onChange: Function;
};

export const SuggestionTypeSwitch = ({ type, onChange }: SuggestionTypeSwitchProps) => {
  const styles = useSuggestionTypeSwitchStyles();

  const searchMode = useMemo(() => (type === SuggestionSearchMode.SEMANTIC_SEARCH ? "1" : "2"), [type]);

  const onSearchModeChange = useCallback(
    (_ev: FormEvent<HTMLDivElement>, data: RadioOnChangeData) => {
      const selectedType =
        data.value === "1" ? SuggestionSearchMode.SEMANTIC_SEARCH : SuggestionSearchMode.KEYWORD_SEARCH;
      onChange(selectedType);
    },
    [onChange]
  );

  return (
    <RadioGroup
      value={searchMode}
      layout="horizontal"
      onChange={onSearchModeChange}
      className={styles.searchTypeContainer}
    >
      <SearchModeRadio
        disabledRadioLabel={false}
        searchMode={searchMode}
        selectedMode="1"
        label="Smart Search"
        tooltipContent={
          <>
            This utilizes AI-driven semantic vector similarity to find relevant text based on the meaning of your query.{" "}
            <br /> <br /> Type in a description of the provision you want to find as if you were describing it to
            another lawyer. <br /> <br /> Ideal for comprehensive, context-aware searches.
          </>
        }
      />

      <SearchModeRadio
        disabledRadioLabel={true}
        selectedMode={searchMode}
        searchMode="2"
        tooltipContent={
          <>
            This employs traditional Boolean logic for targeted text searches.
            <br />
            <br />
            Specify your exact search criteria using operators like AND, OR, NOT for precise, rule-based results. <br />
            <br />
            Perfect for specific, criteria-driven queries.
          </>
        }
        label="Boolean Search"
      />
    </RadioGroup>
  );
};
